// extracted by mini-css-extract-plugin
export default {"root":"_3wS3e","new-custombox":"_173Wm","newCustombox":"_173Wm","theme-based":"_2YqwF","themeBased":"_2YqwF","content":"_1m2I5"};